// Matevara — remove an applied discount straight from the cart drawer (no need to
// open the coupon popup) + keep the coupon modal open after apply.
// Ella shows the applied discount as a read-only chip (.discounts__discount--position)
// with NO remove control. We inject an × on it; clicking it drops the code and
// re-renders the drawer via Ella's updateSections (modal-safe — no innerHTML swap).
(function () {
  'use strict';

  function codeFromChip(chip) {
    var t = (chip.textContent || '').trim();
    var m = t.match(/^([A-Za-z0-9_-]+)/);
    return m ? m[1] : null;
  }

  function removeCode(code) {
    if (!code) return;
    // Prefer Ella's own remove pill in the coupon modal — it re-renders safely.
    var modalPill = document.querySelector(
      '#Drawer-CartCoupon .cart-discount__pill[data-discount-code="' + code + '"] .cart-discount__pill-remove'
    );
    if (modalPill) { modalPill.click(); return; }

    // Fallback: recompute remaining codes + section-aware update, then let Ella swap
    // the section (updateSections keeps the note/coupon modals intact).
    var comp = document.querySelector('cart-drawer-items') || document.querySelector('cart-items-component');
    var sectionId = comp && comp.dataset ? comp.dataset.sectionId : null;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .map(function (d) { return d.code; })
          .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
        var body = { discount: codes.join(',') };
        if (sectionId) body.sections = [sectionId];
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && comp && typeof comp.updateSections === 'function') {
          try { comp.updateSections(data.sections); setTimeout(function () { decorate(document); }, 40); return; }
          catch (e) {}
        }
        window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  function decorate(root) {
    var chips = (root || document).querySelectorAll(
      '#CartDrawer .discounts__discount--position .discounts__discount-text'
    );
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      if (chip.querySelector('.fs-inline-disc-remove')) continue;
      var code = codeFromChip(chip);
      if (!code) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fs-inline-disc-remove';
      btn.setAttribute('aria-label', 'Remove discount ' + code);
      btn.innerHTML = '<svg viewBox="0 0 10 10" width="9" height="9" fill="none"><path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      (function (c) { btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); removeCode(c); }); })(code);
      chip.appendChild(btn);
    }
  }

  // Keep the coupon modal open after a successful apply from inside it.
  function isCouponModalOpen() {
    var m = document.querySelector('#Drawer-CartCoupon');
    return !!m && (m.classList.contains('open') || m.getAttribute('aria-hidden') === 'false');
  }
  function keepCouponModalOpen() {
    var wasOpen = false;
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.closest && e.target.closest('#Drawer-CartCoupon')) wasOpen = true;
    }, true);
    document.addEventListener('DiscountUpdateEvent', function () {
      if (!wasOpen) return;
      wasOpen = false;
      setTimeout(function () {
        if (isCouponModalOpen()) return;
        var opener = document.querySelector('[data-drawer-toggle="#Drawer-CartCoupon"], side-drawer-opener[data-side-drawer="#Drawer-CartCoupon"]');
        var btn = opener ? (opener.querySelector('button') || opener) : null;
        if (btn) btn.click();
      }, 60);
    });
  }

  // The coupon POPUP is teleported out of the cart section, so Ella's section
  // re-render never touches it — after applying OR removing a code the popup's pill
  // list under the input stays stale (apply → pill not shown; remove → pill lingers).
  // Rebuild the whole list from the live cart to mirror what's actually applied.
  function pillMarkup(code) {
    return '<li class="cart-discount__pill" data-discount-code="' + code + '" aria-label="Applied discount code: ' + code + '">' +
      '<p class="cart-discount__pill-code">' + code + '</p>' +
      '<button type="button" class="cart-discount__pill-remove button-unstyled" aria-label="Remove discount ' + code + '">' +
      '<span class="svg-wrapper icon-remove"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 18"><path fill="currentColor" d="M.865 16.043a.75.75 0 0 0 1.06 1.06L9 10.03l7.075 7.075a.75.75 0 1 0 1.06-1.06L10.06 8.97l7.075-7.075A.75.75 0 0 0 16.075.835L9 7.91 1.925.835a.75.75 0 1 0-1.06 1.06L7.94 8.97.865 16.043Z"/></svg></span>' +
      '</button></li>';
  }
  var _syncing = false;
  function syncCouponModalPills() {
    if (_syncing) return;
    var modal = document.querySelector('#Drawer-CartCoupon');
    if (!modal) return;
    var list = modal.querySelector('.cart-discount__codes');
    if (!list) return;
    _syncing = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = (cart.discount_codes || [])
        .filter(function (d) { return d.applicable !== false && d.code; })
        .map(function (d) { return d.code; });
      // 1. drop pills that are no longer applied
      var pills = list.querySelectorAll('.cart-discount__pill');
      for (var i = 0; i < pills.length; i++) {
        var pc = pills[i].dataset.discountCode || '';
        if (codes.indexOf(pc) === -1 && !codes.some(function (c) { return c.toUpperCase() === pc.toUpperCase(); })) {
          pills[i].remove();
        }
      }
      // 2. add pills for applied codes that aren't shown yet
      var shown = [].slice.call(list.querySelectorAll('.cart-discount__pill'))
        .map(function (p) { return (p.dataset.discountCode || '').toUpperCase(); });
      codes.forEach(function (code) {
        if (shown.indexOf(code.toUpperCase()) === -1) {
          list.insertAdjacentHTML('beforeend', pillMarkup(code));
        }
      });
      setTimeout(function () { _syncing = false; }, 50);
    }).catch(function () { _syncing = false; });
  }

  // Instantly hide a popup pill the moment its × is clicked (don't wait for the
   // server round-trip / section re-render — that felt laggy). syncCouponModalPills
   // then reconciles with the real cart afterwards.
  function bindInstantPopupRemove() {
    document.addEventListener('click', function (e) {
      var rm = e.target && e.target.closest ? e.target.closest('#Drawer-CartCoupon .cart-discount__pill-remove') : null;
      if (!rm) return;
      var pill = rm.closest('.cart-discount__pill');
      if (pill) pill.style.display = 'none'; // hide immediately; removed for good on sync
    }, true);
  }

  function init() {
    decorate(document);
    keepCouponModalOpen();
    bindInstantPopupRemove();
    document.addEventListener('DiscountUpdateEvent', function () {
      // run several times to win the race with Ella's async section re-render, which
      // can re-insert a stale pill AFTER our first sync.
      [40, 350, 800, 1500].forEach(function (t) {
        setTimeout(function () { decorate(document); syncCouponModalPills(); }, t);
      });
    });
    var target = document.querySelector('#CartDrawer') || document.body;
    var mo = new MutationObserver(function () { decorate(document); });
    mo.observe(target, { childList: true, subtree: true });

    // Watch the coupon popup's pill list: whenever Ella mutates it (re-render can
    // re-insert a stale pill), reconcile it against the real cart.
    var moModal = new MutationObserver(function () { syncCouponModalPills(); });
    var startModalObserver = function () {
      var list = document.querySelector('#Drawer-CartCoupon .cart-discount__codes');
      if (list && !list.__fsObserved) { list.__fsObserved = true; moModal.observe(list, { childList: true }); }
    };
    startModalObserver();
    // the modal may not exist yet — retry a few times as it renders/teleports
    [500, 1500, 3000].forEach(function (t) { setTimeout(startModalObserver, t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
